import { posToDOMRect } from "@tiptap/core";
import { Sound, SoundCloudSmall, SoundSmall, SpotifySmall } from "@wix/wix-ui-icons-common";
import {
  quickActionsModalSections,
  RicosPluginToolbarNames
} from "./../ricos-types/index.js";
import { changeSelectionToEndOfTextBlock } from "./../wix-rich-content-common/index.js";
import {
  AUDIO_INSERT_AUDIO_MODAL_ID,
  AUDIO_INSERT_SOUNDCLOUD_MODAL_ID,
  AUDIO_INSERT_SPOTIFY_MODAL_ID
} from "./consts.js";
import { audioConverter } from "./converters/audio-converter.js";
import { DEFAULT_CONFIGS, RICOS_DEFAULTS } from "./defaults.js";
import { getAddButtons } from "./getAddButtons.js";
import { getToolbarButtons } from "./getToolbarButtons.js";
import { InsertModal } from "./modals/InsertModal.js";
import { tiptapExtensions } from "./tiptap/tiptap.js";
import { AUDIO_TYPE } from "./types.js";
const pluginAudio = (config = {}) => {
  return {
    config: { ...DEFAULT_CONFIGS.editor, ...config },
    type: AUDIO_TYPE,
    tiptapExtensions,
    pmMarkConverters: [],
    pmNodeConverters: [audioConverter],
    toolbar: {
      names: [RicosPluginToolbarNames.AUDIO],
      getButtons: (config2, services) => getToolbarButtons(config2, services)
    },
    getAddButtons: (config2, services) => getAddButtons(config2, services),
    getQuickActions: ({ config: config2, pluginServices }) => {
      const { handleFileSelection, disableDownload = true } = config2 || {};
      const modalBaseProps = {
        handleFileSelection
      };
      const isMobile = pluginServices.context.isMobile;
      return [
        {
          id: "audioFile",
          title: "QuickActionsPlugin_ActionTitle_AudioFile",
          icon: isMobile ? Sound : SoundSmall,
          section: quickActionsModalSections.Media,
          tags: ["music", "sound", "podcast", "voice", "recording", "song", "clip", "track"],
          command: ({ modalService, editor }) => {
            changeSelectionToEndOfTextBlock(editor);
            modalService.togglePluginPanel({
              id: AUDIO_INSERT_AUDIO_MODAL_ID,
              Component: InsertModal,
              componentProps: {
                componentData: { ...RICOS_DEFAULTS, disableDownload },
                modalId: AUDIO_INSERT_AUDIO_MODAL_ID,
                ...modalBaseProps
              },
              isMobile,
              positioning: {
                referenceElement: {
                  getBoundingClientRect: () => posToDOMRect(
                    editor.view,
                    editor.view.state.selection.from,
                    editor.view.state.selection.to
                  )
                },
                placement: isMobile ? "bottom" : "bottom-start"
              },
              mobileLayout: "drawer"
            });
          }
        },
        {
          id: "soundcloud",
          title: "QuickActionsPlugin_ActionTitle_SoundCloud",
          icon: SoundCloudSmall,
          section: quickActionsModalSections.Embed,
          tags: [
            "music",
            "sound",
            "podcast",
            "voice",
            "recording",
            "song",
            "clip",
            "link",
            "streaming",
            "track"
          ],
          command: ({ modalService, editor }) => {
            changeSelectionToEndOfTextBlock(editor);
            modalService.togglePluginPanel({
              id: AUDIO_INSERT_SOUNDCLOUD_MODAL_ID,
              Component: InsertModal,
              componentProps: {
                componentData: { ...RICOS_DEFAULTS },
                modalId: AUDIO_INSERT_SOUNDCLOUD_MODAL_ID,
                embedType: true,
                ...modalBaseProps
              },
              isMobile,
              positioning: {
                referenceElement: {
                  getBoundingClientRect: () => posToDOMRect(
                    editor.view,
                    editor.view.state.selection.from,
                    editor.view.state.selection.to
                  )
                },
                placement: isMobile ? "bottom" : "bottom-start"
              },
              mobileLayout: "drawer"
            });
          }
        },
        {
          id: "spotify",
          title: "QuickActionsPlugin_ActionTitle_SpotifyTrack",
          icon: SpotifySmall,
          section: quickActionsModalSections.Embed,
          tags: [
            "music",
            "sound",
            "podcast",
            "voice",
            "recording",
            "song",
            "clip",
            "link",
            "streaming",
            "track",
            "playlist"
          ],
          command: ({ modalService, editor }) => {
            changeSelectionToEndOfTextBlock(editor);
            modalService.togglePluginPanel({
              id: AUDIO_INSERT_SPOTIFY_MODAL_ID,
              Component: InsertModal,
              componentProps: {
                componentData: { ...RICOS_DEFAULTS },
                modalId: AUDIO_INSERT_SPOTIFY_MODAL_ID,
                embedType: true,
                ...modalBaseProps
              },
              isMobile,
              positioning: {
                referenceElement: {
                  getBoundingClientRect: () => posToDOMRect(
                    editor.view,
                    editor.view.state.selection.from,
                    editor.view.state.selection.to
                  )
                },
                placement: isMobile ? "bottom" : "bottom-start"
              },
              mobileLayout: "drawer"
            });
          }
        }
      ];
    }
  };
};
export {
  pluginAudio
};
//# sourceMappingURL=editor.js.map

import { injectCss } from "./viewer-styles-inject.js";
injectCss();
